<template>
  <div>
    <modal-header v-if="showModalOnboarding" />
    <onboarding
      v-if="isOnboarding"
      :account="account.name"
      :currentStep="onboardingStep"
      @close="closeOnboarding"
    />

    <layout-kyc v-if="isKycRouteEnabled" />
    <layout-secret-key-outdated v-else-if="isSecretKeyOutdatedEnabled" />
    <layout-core v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { isSecretKeyOutdatedEnabled } from '@permissions/keys.permissions'

import LayoutCore from '@/layouts/LayoutCore.vue'
import LayoutKyc from '@/layouts/LayoutKyc.vue'
import LayoutSecretKeyOutdated from '@/layouts/LayoutSecretKeyOutdated.vue'

export default {
  name: 'Motherboard',
  components: {
    LayoutCore,
    LayoutKyc,
    LayoutSecretKeyOutdated,
    Onboarding: () =>
      import(
        /* webpackChunkName: "Onboarding" */ '@/components/project/globals/Onboarding.vue'
      ),
    ModalHeader: () =>
      import(
        /* webpackChunkName: "ModalHeader" */ '@/components/project/globals/ModalHeader.vue'
      )
  },

  computed: {
    ...mapGetters([
      'merchantId',
      'account',
      'onboardingStep',
      'showModalHeaderOnboarding',
      'isOnboardingSummaryClosed',
      'showOnboarding',
      'componentIsEnabled',
      'isEmployee',
      'isKycRouteEnabled',
      'secretKeyList',
      'isTestAccount'
    ]),

    isOnboarding () {
      return this.showOnboarding && !this.isEmployee
    },

    showModalOnboarding () {
      return (
        (this.showModalHeaderOnboarding || !this.isOnboardingSummaryClosed) &&
        this.componentIsEnabled('global', 'modalHeader')
      )
    },

    isSecretKeyOutdatedEnabled () {
      return isSecretKeyOutdatedEnabled(
        this.secretKeyList?.items,
        this.merchantId,
        this.isTestAccount,
        this.isEmployee
      )
    }
  },

  methods: {
    ...mapActions(['TOGGLE_ONBOARDING']),
    closeOnboarding () {
      this.TOGGLE_ONBOARDING(false)
    }
  }
}
</script>

<style>
#atlwdg-trigger {
  background: var(--brand--le--primary-color--base);
  color: #fff !important;
  border: none;
  box-shadow: none;
  border-radius: 4px 0 0 0;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 11px;
  padding: 6px 12px;
  z-index: 0;
}
._mode_dark #atlwdg-trigger {
  background: var(--brand--de--primary-color--base);
  color: #272829 !important;
}
._mode_light #atlwdg-trigger {
  background: var(--brand--le--primary-color--base);
  color: #fff !important;
}
</style>
